import { SectionHeading } from './SectionHeading'

const ACHIEVEMENTS = [
  {
    no: 1,
    image: '/images/product_no1.png',
    title: '金融系取引スマホアプリ',
    sub: '仮想通貨・株式・FX・ウォレット',
    description:
      '仮想通貨に限らず、株式やFXなどあらゆる金融取引のリアルタイムトレードアプリが開発可能です。仮想通貨においてはウォレットアプリの開発も可能です。'
  },
  {
    no: 2,
    image: '/images/product_no2.png',
    title: '金融取引系WEBフロントシステム',
    sub: 'リアルタイム表示更新',
    description:
      '金融取引に必要な、リアルタイム表示更新機能を、様々な環境向けに開発可能です。'
  },
  {
    no: 3,
    image: '/images/product_no3.png',
    title: '電子チケット予約販売システム',
    sub: '販売システム・サイト・アプリ一式',
    description:
      'フロントだけでなく、チケット販売システム・チケット販売サイト・チケット販売アプリなど、トータルのシステムを開発可能です。'
  },
  {
    no: 4,
    image: '/images/product_no4.png',
    title: 'オンライン展示会システム',
    sub: '出展企業アピール・マッチング・WEB会議・CMS',
    description:
      '出展企業アピール・商品一覧・おすすめ企業・マッチングや面談予約・WEB会議システム・マイページ／CMS機能など展示会で必要十分な機能を開発可能です。'
  },
  {
    no: 5,
    image: '/images/product_no5.png',
    title: 'オンライン文書管理システム',
    sub: '会計士と顧客企業間のやり取り履歴可視化',
    description:
      '決算書類や税務申告等の、会計士と顧客企業のやり取りをオンラインで履歴管理・可視化。上長だけに見せるメッセージや送信許可機能など、顧客のユースケースに沿ったシステム開発が可能です。'
  },
  {
    no: 6,
    image: '/images/product_no6.png',
    title: '求人募集システム',
    sub: '掲載・応募者管理・マッチング・外部連携',
    description:
      '求人情報の掲載／管理システム、応募者管理機能とマッチング機能、外部求人サイトとのデータ連携など、一通りの機能を開発可能です。'
  },
  {
    no: 7,
    image: '/images/product_no7.png',
    title: '金融系口座開設アプリ/システム',
    sub: '銀行・クレジットカード口座開設フロー',
    description:
      '銀行口座・クレジットカード口座などの金融口座の開設をアプリで行うための一連のシステムを開発できます。'
  },
  {
    no: 8,
    image: '/images/product_no8.png',
    title: 'ARシステム開発',
    sub: '観光ガイド・教育・建築支援等',
    description:
      '拡張現実（AR）技術を活用したアプリケーション開発。行先案内や観光ガイド、教育・建築支援など、様々なシーンに応用できます。'
  },
  {
    no: 9,
    image: '/images/product_no9.png',
    title: 'NFCチップ制御アプリ/システム',
    sub: '歩行診断アプリとのネイティブ連携',
    description:
      'スマホの非接触チップ制御をネイティブプログラムで行い、Unityで開発した歩行診断アプリに受け渡し。スマホのNFCチップ制御全般のプログラムが可能です。'
  },
  {
    no: 10,
    image: '/images/product_no10.png',
    title: '位置情報を活用したサービス',
    sub: 'GPS・地図データ連携アプリ',
    description:
      'GPS受信データと地図データとの連携、各種の地図コンテンツと連携したアプリケーション開発が可能です。'
  },
  {
    no: 11,
    image: '/images/product_no11.png',
    title: 'オンライン投資用不動産販売サイト',
    sub: 'シミュレーション・入札・CMS・SEO',
    description:
      '借入可能額の計算と収支シミュレーション・物件への入札システム・不動産物件管理用CMS・SEO対策など、様々なWEBサイト、ECサイトの開発が可能です。'
  },
  {
    no: 12,
    image: '/images/product_no12.png',
    title: '会議ログシステム',
    sub: 'クラウド型議事録共有システム',
    description:
      'HTML5+CSS+JavaScript（TypeScript）を用いたフロントアプリケーション。React・Next・Vue等のフレームワークを利用したSPA開発。AWSの各種開発環境を用いたサービス開発が可能です。'
  },
  {
    no: 13,
    image: '/images/product_no13.png',
    title: 'PUSH通知配信システム',
    sub: '独自のPUSH通知配信システム',
    description:
      '特定のユーザーのスマートフォンに、通知を行うためのシステムを提供いたします。'
  },
  {
    no: 14,
    image: '/images/product_no14.png',
    title: 'モーションキャプチャーゲーム',
    sub: '専用カメラでアバター操作',
    description:
      'モーションキャプチャー専用のカメラで人体の動きをトレースし、ゲーム上のアバターを操作してゲームを遊ぶことができます。モーションキャプチャーシステムを使用した開発が可能です。'
  }
]

export function Achievements() {
  return (
    <section
      id="achievements"
      className="section-wrapper relative overflow-hidden bg-slate-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-slate-50 via-white to-slate-100" />

      <div className="container-inner relative z-10">
        <SectionHeading subtitle="Development Achievements" title="開発実績" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 sm: gap-4 md:gap-8 lg:gap-8">
          {ACHIEVEMENTS.map((item, i) => (
            <div
              key={item.no}
              className={`flip-card h-48 animate-on-scroll animate-on-scroll-delay-${(i % 4) + 1}`}
            >
              <div className="flip-card-inner">
                {/* 表: 画像 + タイトル + サブ */}
                <div className="flip-card-front bg-white border border-slate-200 rounded-xl overflow-hidden hover:border-brand-cyan/40 hover:shadow-md transition-all duration-300">
                  <div className="relative overflow-hidden h-28">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-x-0 bottom-0 h-[1px] bg-gradient-to-r from-transparent via-brand-cyan to-transparent" />
                  </div>
                  <div className="p-4">
                    <p className="text-brand-navy text-sm font-semibold leading-snug">
                      {item.title}
                    </p>
                    {item.sub && (
                      <p className="text-brand-navy/50 text-xs mt-1 leading-snug">
                        {item.sub}
                      </p>
                    )}
                  </div>
                </div>

                {/* 裏: 説明文 */}
                <div className="flip-card-back bg-brand-navy rounded-xl p-4 flex flex-col justify-center overflow-hidden">
                  <p className="text-white text-xs font-semibold leading-snug mb-2">
                    {item.title}
                  </p>
                  <p className="text-white/75 text-xs leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
